import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Button from 'layout/atoms/Button/Button';
import InputLabel from 'layout/atoms/InputLabel';
import InputNumber from 'layout/atoms/InputNumber';
import Label from 'layout/atoms/Label';
import Loader from 'layout/atoms/Loader/Loader';
import Modal from 'layout/atoms/Modal/Modal';
import ParameterDetails from 'layout/atoms/ParameterDetails/ParameterDetails';
import CurrencySelect from 'layout/molecules/CurrencySelect';
import EmptyState from 'layout/molecules/EmptyState/EmptyState';
import Grid from 'layout/molecules/Grid/Grid';
import { addSharedComponent, fetchComponentDetails, fetchComponentVariants, selectComponentDetails, selectComponentDetailsStatus, selectComponentVariants, selectVariantsStatus, } from 'store/componentDetailsSlice';
import { resetCategories, resetFilters } from 'store/componentsSlice';
import { closeModal, closeSidebar, openSidebar } from 'store/layoutSlice';
import { selectTennantData } from 'store/userSlice';
function AddSharedComponent() {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation(['specification', 'common']);
    const componentDetails = useSelector(selectComponentDetails);
    const status = useSelector(selectComponentDetailsStatus);
    const tenantId = useSelector(selectTennantData).id;
    const variants = useSelector(selectComponentVariants);
    const variantsStatus = useSelector(selectVariantsStatus).fetch;
    const [newVariants, setNewVariants] = useState([]);
    useEffect(() => {
        if (variantsStatus === 'idle') {
            dispatch(fetchComponentVariants(componentDetails === null || componentDetails === void 0 ? void 0 : componentDetails.id));
        }
        if (variantsStatus === 'succeeded') {
            setNewVariants(variants);
        }
    }, [dispatch, componentDetails === null || componentDetails === void 0 ? void 0 : componentDetails.id, variantsStatus, variants]);
    useEffect(() => { }, [newVariants]);
    const handlePriceChange = (e) => {
        const variantId = e.target.name;
        const newPrice = parseFloat(e.target.value || '0');
        setNewVariants((variants) => variants.map((variant) => variant.id === variantId
            ? Object.assign(Object.assign({}, variant), { currentPrice: Object.assign(Object.assign({}, variant.currentPrice), { price: newPrice }) }) : variant));
    };
    const allValuesNull = (arrays) => {
        return arrays.every((innerArray) => innerArray.at(-1) === null);
    };
    const handleCurrencyChange = (id, isoCode, name) => {
        setNewVariants((variants) => variants.map((variant) => variant.id === name
            ? Object.assign(Object.assign({}, variant), { currentPrice: Object.assign(Object.assign({}, variant.currentPrice), { currency: {
                        id,
                        isoCode,
                    } }) }) : variant));
    };
    const handleAddSharedComponent = useCallback(() => {
        dispatch(addSharedComponent({
            componentId: componentDetails === null || componentDetails === void 0 ? void 0 : componentDetails.id,
            tenantId,
            variantsPrices: newVariants.map((variant) => {
                var _a;
                return [
                    variant.id,
                    ((_a = variant.currentPrice.currency) === null || _a === void 0 ? void 0 : _a.id) || null,
                    variant.currentPrice.price,
                ];
            }),
        }))
            .unwrap()
            .then((response) => {
            var _a, _b, _c;
            const newComponentId = (_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.assignProductToTenant) === null || _b === void 0 ? void 0 : _b.product) === null || _c === void 0 ? void 0 : _c.id;
            dispatch(resetFilters());
            dispatch(resetCategories());
            history.push('/components/all');
            dispatch(closeModal({ name: 'addSharedComponent' }));
            dispatch(closeSidebar({ name: 'sharedComponentDetails' }));
            dispatch(fetchComponentDetails({ componentId: newComponentId }));
            dispatch(openSidebar({
                name: 'componentDetails',
                id: newComponentId,
            }));
        });
    }, [dispatch, componentDetails === null || componentDetails === void 0 ? void 0 : componentDetails.id, tenantId, newVariants, history]);
    const handleCloseModal = useCallback(() => {
        dispatch(closeModal({ name: 'addSharedComponent' }));
    }, [dispatch]);
    return (React.createElement(Modal, { name: "addSharedComponent", size: "s", header: React.createElement(Label, { weight: "strong" }, t('fill_in_the_missing_information')), footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { theme: "ghost", onClick: handleCloseModal }, t('common:cancel')),
            React.createElement(Button, { color: "primary", submit: true, onClick: handleAddSharedComponent, loading: status.addShared === 'loading', disabled: variantsStatus === 'loading' || variantsStatus === 'idle' }, allValuesNull(newVariants.map((variant) => {
                var _a;
                return [
                    variant.id,
                    ((_a = variant.currentPrice.currency) === null || _a === void 0 ? void 0 : _a.id) || null,
                    variant.currentPrice.price,
                ];
            }))
                ? t('skip_and_add_product')
                : t('add_component'))) }, variantsStatus === 'loading' || variantsStatus === 'idle' ? (React.createElement(Loader, null)) : (React.createElement(Grid, null, newVariants.length > 0 ? (newVariants.map((variant) => {
        var _a;
        return (React.createElement(Grid, { columns: 4 },
            React.createElement("div", null,
                React.createElement(InputLabel, { htmlFor: "price", text: t('common:price') }),
                React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        minWidth: '200px',
                    } },
                    React.createElement(InputNumber, { name: variant.id, value: variant.currentPrice.price, onChange: handlePriceChange, decimal: 2, noMaxWidth: true }),
                    React.createElement(CurrencySelect, { value: ((_a = variant.currentPrice.currency) === null || _a === void 0 ? void 0 : _a.isoCode) || '', name: variant === null || variant === void 0 ? void 0 : variant.id, onChange: handleCurrencyChange, useDefaultCurrencyFallback: true }))),
            variant.size && (React.createElement(ParameterDetails, { size: "s", label: t('common:size'), value: variant.size.value })),
            variant.color && (React.createElement(ParameterDetails, { size: "s", label: t('common:color'), value: variant.color.name }))));
    })) : (React.createElement(EmptyState, { size: "s" }))))));
}
export default AddSharedComponent;
